import { prefixReplacer } from './prefixReplacer';
export const html = (strings, ...values) => prefixReplacer(String.raw({ raw: strings }, ...values));
